import { Formik } from 'formik';
import moment from 'moment';
import React, { useCallback } from 'react';
import { SearchType } from 'v2/interfaces/financial';
import { initialFilter } from 'v2/services/financialStatement/statement';
import * as Yup from 'yup';

import type { EFinancialStatementTabs, FinancialStatementFilter } from 'v2/interfaces/financial';

import Form from './Form';

import type { FormikProps } from 'formik';

interface IFilterProps {
  currentTab: EFinancialStatementTabs;
}

const formValidation = Yup.object().shape({
  search_text: Yup.string()
    .when('search_type', {
      is: SearchType.EMAIL,
      then: Yup.string().email('E-mail inválido'),
    })
    .when('search_type', {
      is: SearchType.DOCUMENT,
      then: Yup.string().test('length', 'CPF/CNPJ inválido', (val) => val.length === 11 || val.length === 14),
    }),
  dates: Yup.mixed().test('period', 'Período máximo 180 dias', (value) =>
    moment(value[1], 'DD/MM/YYYY').isSameOrBefore(moment(value[0], 'DD/MM/YYYY').add(179, 'days'))
  ),
});

function Filter({ currentTab }: IFilterProps) {
  const onSubmit = useCallback((values: FinancialStatementFilter, { setSubmitting }: FormikProps<FinancialStatementFilter>) => {
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialFilter} onSubmit={onSubmit} validationSchema={formValidation}>
      {(props) => <Form {...props} currentTab={currentTab} />}
    </Formik>
  );
}

export default Filter;
